// =============================================================================
// VINUM - Favorites API
// Aligned with backend /favorites endpoints.
// I preferiti sono memorizzati lato server come coppie (userId, itemId);
// l'API espone la lista di itemId e le operazioni add/remove.
// =============================================================================

import { apiGet, apiPost, apiDelete } from './client';

export const FavoritesAPI = {
  /**
   * Lista degli itemId preferiti dell'utente corrente.
   * GET /favorites -> { itemIds: string[] }
   */
  async list(): Promise<string[]> {
    const response = await apiGet<any>('/favorites');
    const ids = Array.isArray(response) ? response : response?.itemIds;
    return Array.isArray(ids) ? ids.map(String) : [];
  },

  /**
   * Aggiunge un articolo ai preferiti (idempotente lato server).
   * POST /favorites { itemId }
   */
  async add(itemId: string): Promise<void> {
    await apiPost('/favorites', { itemId });
  },

  /**
   * Rimuove un articolo dai preferiti (idempotente lato server).
   * DELETE /favorites/:itemId
   */
  async remove(itemId: string): Promise<void> {
    await apiDelete(`/favorites/${itemId}`);
  },
};
